import { render, staticRenderFns } from "./AiEventList.vue?vue&type=template&id=032b1aa0&"
import script from "./AiEventList.vue?vue&type=script&lang=js&"
export * from "./AiEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports